<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" centered destroyOnClose title="货位检索" width="70%">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"/>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.no.length > 10" :key="row.id" :title="row.no">
          <a-tag :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">
            {{`${row.no.slice(0, 10)}...`}}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">
          {{row.no}}
        </a-tag>
      </template>
    </template>
    <a-space style="margin-top: -22px">
      <a-input-search v-model="query['storageRoom.name']" :placeholder="$t('business.label.storageRoomName')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['zone.name']" :placeholder="$t('business.label.zoneName')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query.no" :placeholder="$t('business.label.locationNo')" @pressEnter="search" @search="search"/>
      <a-select v-model="query.locationStatus" :placeholder="$t('business.label.locationStatus')" allowClear style="width: 150px" @change="search">
        <a-select-option v-for="d in locationStatus" :key="d.ordinal">{{d.name}}</a-select-option>
      </a-select>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="no" title="business.label.locationNo"/>
      <vxe-column field="name" title="business.label.locationName"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
      <vxe-column field="zone.name" title="business.label.zone"/>
      <vxe-column field="region.no" title="business.label.region"/>
      <vxe-column title="business.label.locationStatus" field="locationStatus">
        <template #default="{ row }">{{convert(row.locationStatus, locationStatus, 'ordinal', 'name')}}</template>
      </vxe-column>
      <vxe-column field="roadway" title="business.label.roadway"/>
      <vxe-column field="x" title="business.label.row"/>
      <vxe-column field="y" title="business.label.layer"/>
      <vxe-column field="z" title="business.label.column"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="automatic" title="business.label.automatic" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import { convert } from '@/utils/util'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'LocationModal',
  data() {
    return {
      show: true,
      page: 1,
      size: 15,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: { no: '', locationStatus: undefined, 'storageRoom.name': '', 'zone.name': '' },
      args: null,
      record: undefined,
      locationStatus: [],
      selectedRows: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.6)
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    }
  },
  methods: {
    convert,
    init(args) {
      this.query = { no: '' }
      this.locationStatus = []
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.loading = true
      setTimeout(() => {
        this.loadingPreData()
      }, 300)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('locationFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadingPreData() {
      let promiseArr = []
      if (this.locationStatus.length === 0) {
        promiseArr.push(new Promise(resolve => {
          findEnum('LocationStatus').then(res => {
            if (res.success) {
              this.locationStatus = res.result
            }
          }).finally(() => {
            resolve()
          })
        }))
      }
      Promise.all(promiseArr).then(() => this.getData())
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>